export default __webpack_public_path__ + "static/media/ic_map_latam.83f2fc09.svg";